import type { AllRouteEndpoints } from "../routeTypes";

/** Mirrors `DataMapper::EventCatalogSlice::MAX_NAMES`; the backend rejects longer requests. */
export const EVENT_CATALOG_SLICE_MAX_NAMES = 200;

/** The slice is a read served over POST (names lists can be long); it invalidates nothing. */
export const postAppsAppGroupIdUserImportsImportIdEventCatalogSliceCacheKeys: AllRouteEndpoints[] = [];
